// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7c499109","703":"b7cc5fd6","787":"38f8ddca"}[chunkId] + ".chunk.js";
};